export default __webpack_public_path__ + "static/media/fizz.1d84ddc7.png";